import client, { url } from './client';
import qs from 'qs';

export const loadDashboardYear = ({ centerID, socketKey, year }) => {
  const queryString = qs.stringify({ centerID, socketKey, year });
  return client.get(`${url}/api/statistics/dashboard/year?${queryString}`);
};

export const loadDashboardMonth = ({ centerID, socketKey, year, month }) => {
  const queryString = qs.stringify({ centerID, socketKey, year, month });
  return client.get(`${url}/api/statistics/dashboard/month?${queryString}`);
};

export const loadDashboardDay = ({ centerID, socketKey, year, month, day }) => {
  const queryString = qs.stringify({ centerID, socketKey, year, month, day });
  return client.get(`${url}/api/statistics/dashboard/day?${queryString}`);
};

export const loadMembershipList = ({ clubID, socketKey, clubItemID, state, startAge, endAge, sex, isViewPoint, startTime, endTime }) => {
  const queryString = qs.stringify({
    socketKey,
    clubItemID,
    state,
    startAge,
    endAge,
    sex,
    isViewPoint,
    startTime,
    endTime
  });
  return client.get(`${url}/api/statistics/membership/${clubID}?${queryString}`);
};